import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=70685714&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=70685714&prod&lang=scss&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=70685714&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70685714",
  null
  
)

export default component.exports